<template>
  <crm-side-panel @handleClose="handleCloseDetail">
    <div class="side-panel-content dictionary-detail-content">
      <div class="side-panel-buttons">
        <crm-button
          v-if="auth.categoryAdd && auth.categoryAdd.toggleStatus"
          :buttonType="'secondary'"
          :size="'mini'"
          :text="'新增'"
          @click="isAddDialogVisible = true"
        >
        </crm-button>
      </div>
      <div class="header">
        <p class="header-title">字典项</p>
      </div>
      <!-- 搜索条 -->
      <div class="search-bar">
        <el-col :span="6">
          <el-input
            class="search-input"
            placeholder="字典项名称"
            v-model="name"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="handleSearchList"
              style="cursor: pointer"
            ></i>
          </el-input>
        </el-col>
      </div>
      <!-- 团队成员列表 -->
      <el-table
        :data="dictionaryDetailList.results"
        v-loading="loading"
        height="100%"
        class="dictionary-table"
        style="width: 100%"
      >
        <el-table-column prop="dictionaryName" align="center" label="字典名称">
        </el-table-column>
        <el-table-column prop="name" align="center" label="字典项名称">
        </el-table-column>
        <el-table-column prop="remark" align="center" label="备注">
        </el-table-column>
        <el-table-column
          v-if="auth.categoryDetail && auth.categoryDetail.toggleStatus"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              @click="handleOpenModify(scope)"
              type="text"
              size="small"
              v-if="auth.categoryUpdate && auth.categoryUpdate.toggleStatus"
              >编辑</el-button
            >
            <el-button
              @click="handleDelete(scope)"
              type="text"
              size="small"
              v-if="auth.categoryDelete && auth.categoryDelete.toggleStatus"
              >删除</el-button
            >
            <el-button
              size="small"
              v-if="
                !(scope.$index === 0 && pageNumber === 1) &&
                  auth.categorySort &&
                  auth.categorySort.toggleStatus
              "
              @click="handleMovePosition(scope, 'upMove')"
              class="circle-button"
              type="primary"
              icon="el-icon-arrow-up"
            ></el-button>
            <el-button
              size="small"
              v-if="
                !(
                  scope.$index === dictionaryDetailList.results.length - 1 &&
                  pageNumber === dictionaryDetailList.totalPages
                ) &&
                  auth.categorySort &&
                  auth.categorySort.toggleStatus
              "
              @click="handleMovePosition(scope, 'downMove')"
              class="circle-button"
              type="primary"
              icon="el-icon-arrow-down"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :current-page="dictionaryDetailList.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="dictionaryDetailList.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="dictionaryDetailList.totalCount"
        >
        </el-pagination>
      </div>

      <!-- 新增字典弹窗 -->
      <el-dialog
        title="新增字典"
        :visible.sync="isAddDialogVisible"
        :width="'500px'"
        append-to-body
      >
        <div class="dialog-body">
          <el-form label-width="100px" class="clearfix">
            <el-form-item label="字典名称">
              <el-input
                v-model="dictionaryDetailKey.name"
                disabled
                :maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="字典项名称">
              <el-input v-model="addForm.name"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                v-model="addForm.remark"
                type="textarea"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <crm-button
            :buttonType="'plain'"
            :text="'取消'"
            @click="cancelAddDictionary"
          >
          </crm-button>
          <crm-button :text="'确定'" @click="handleAddDictionary"> </crm-button>
        </div>
      </el-dialog>

      <!-- 编辑字典 -->
      <el-dialog
        title="编辑字典"
        :visible.sync="isUpdateDialogVisible"
        :width="'500px'"
        append-to-body
      >
        <div class="dialog-body">
          <el-form label-width="100px" class="clearfix">
            <el-form-item label="字典名称">
              <el-input
                v-model="updateForm.dictionaryName"
                disabled
                :maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="字典项名称">
              <el-input v-model="updateForm.name"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                v-model="updateForm.remark"
                type="textarea"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <crm-button
            :buttonType="'plain'"
            :text="'取消'"
            @click="isUpdateDialogVisible = false"
          >
          </crm-button>
          <crm-button :text="'确定'" @click="handleUpdateDictionary">
          </crm-button>
        </div>
      </el-dialog>
    </div>
  </crm-side-panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { formatTimeShow } from '@/scripts/utils';
import CrmSidePanel from '~component/base/crmSidePanel.vue';
import CrmButton from '@/components/base/crmButton';

export default {
  components: {
    CrmSidePanel,
    CrmButton,
  },
  filters: {
    formatTimeShow,
  },
  props: {
    dictionaryDetailKey: {
      type: Object,
    },
  },
  data() {
    return {
      isUpdateDialogVisible: false,
      isAddDialogVisible: false,
      pageSize: 10,
      pageNumber: 1,
      code: 1,
      loading: false,
      name: '',
      updateForm: {
        dictionaryName: '',
        name: '',
        remark: '',
        code: '',
        uid: '',
      },
      addForm: {
        name: '',
        remark: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      crmUsers: 'backstage/crmUsers',
      auth: 'authority/auth',
      dictionaryDetailList: 'backstage/dictionaryDetailList',
    }),
  },
  created() {
    this.handleSearchList();
  },
  methods: {
    ...mapActions({
      getDictionaryDetailList: 'backstage/getDictionaryDetailList',
      getUserList: 'backstage/getUserList',
      getDictionaryDetail: 'backstage/getDictionaryDetail',
      addUser: 'backstage/addUser',
      deleteUser: 'backstage/deleteUser',
      deleteDictionaryDetail: 'backstage/deleteDictionaryDetail',
      updateDictionaryDetail: 'backstage/updateDictionaryDetail',
      addDictionaryDetail: 'backstage/addDictionaryDetail',
      sortSave: 'backstage/sortSave',
    }),
    handleCloseDetail() {
      this.$emit('handleCloseDetail');
    },
    handleStopHideDialog(events) {
      events.stopPropagation();
    },
    handleOpenModify(scope) {
      this.updateForm = {
        dictionaryName: scope.row.dictionaryName,
        name: scope.row.name,
        remark: scope.row.remark,
        code: scope.row.code,
        uid: scope.row.uid,
      };
      this.isUpdateDialogVisible = true;
    },
    handleSearch() {
      this.getDictionaryDetailList({
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        name: this.name,
        code: this.dictionaryDetailKey.code,
      });
    },
    // 获取表格数据
    handleSearchList() {
      this.loading = true;
      this.getDictionaryDetailList({
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        code: this.dictionaryDetailKey.code,
        name: this.name,
      }).finally(() => {
        this.loading = false;
      });
    },
    handleAddDictionary() {
      this.addDictionaryDetail({
        code: this.dictionaryDetailKey.code,
        name: this.addForm.name,
        remark: this.addForm.remark,
      }).then(() => {
        this.handleSearchList();
        this.isAddDialogVisible = false;
        this.addForm = {
          name: '',
          remark: '',
        };
      });
    },
    cancelAddDictionary() {
      this.isAddDialogVisible = false;
      this.addForm = {
        name: '',
        remark: '',
      };
    },
    handleUpdateDictionary() {
      this.updateDictionaryDetail({
        code: this.updateForm.code,
        name: this.updateForm.name,
        remark: this.updateForm.remark,
        uid: this.updateForm.uid,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '修改成功',
        });
        this.handleSearchList();
        this.isUpdateDialogVisible = false;
      });
    },
    handleDelete(scope) {
      this.$confirm(`确定删除${scope.row.name}？`).then(() => {
        this.deleteDictionaryDetail({
          uid: scope.row.uid,
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
          });
          this.handleSearchList();
        });
      });
    },
    handleMovePosition(scope, type) {
      this.sortSave({
        uid: scope.row.uid,
        sortCode: type,
      }).then(() => {
        this.handleSearchList();
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageNumber = 1;
      this.getDictionaryDetailList({
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        name: this.name,
        code: this.dictionaryDetailKey.code,
      });
    },
    handlePageChange(index) {
      this.pageNumber = index;
      this.getDictionaryDetailList({
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        name: this.name,
        code: this.dictionaryDetailKey.code,
      });
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.dictionary-detail-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  padding: 0 20px;
  .header {
    .header-title {
      margin: 0 -20px 30px;
      padding-left: 30px;
      background-color: @bg--primary;
      height: 40px;
      line-height: 40px;
      color: #fff;
    }
  }
  .search-bar {
    padding-left: 10px;
    margin-bottom: 20px;
  }
}
</style>
